import { Modal, Space, Card, Row, Col, Flex, Button } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as PDFIcon } from "../../../../assets/icon/pdfIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg";
import { ReactComponent as TextFileIcon } from "../../../../assets/icon/textFileIcon.svg";
import dayjs from "dayjs"

function PND1ReportModal({
    isModalOpen,
    setIsModalOpen,
    exportPND1ReportDocument = () => { },
    exportPND1Report = () => { },
    exportPND1ReportTxt = () => { },
    exportPND1ReportZip = () => { },
    searchValues = {},
    isDownloadDoc = false,
    isDownload = false,
    isDownloadTxt = false,
    isDownloadZip = false
}) {
    const { t } = useTranslation();

    const handleExportDocument = () => {
        exportPND1ReportDocument({
            year: searchValues.year?.year() || dayjs().year(),
            month: searchValues.month
        });
    };

    const handleExportReport = () => {
        exportPND1Report({
            year: searchValues.year?.year() || dayjs().year(),
            month: searchValues.month
        });
    };


    const handleExportTxtReport = () => {
        exportPND1ReportTxt({
            year: searchValues.year?.year() || dayjs().year(),
            month: searchValues.month
        });
    };

    const handleExportZipReport = () => {
        exportPND1ReportZip({
            year: searchValues.year?.year() || dayjs().year(),
            month: searchValues.month
        });
    };

    return (
        <Modal
            title={<span color="#42526D">{t("report.label.download_file")}</span>}
            destroyOnClose
            open={isModalOpen}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <span style={{ fontSize: "14px", color: "#667085" }}>
                    {t("report.modal.description")}
                </span>
                <Card
                    style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                    styles={{ body: { padding: "16px" } }}
                >
                    <Row style={{ width: "100%" }}>
                        <Col span={16}>
                            <Flex gap={16} align="center">
                                <PDFIcon />
                                <Flex vertical>
                                    <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("report.pnd1_doc")}</span>
                                    <span style={{ color: "#42526D" }}>{t("common.pdf_file")}</span>
                                </Flex>
                            </Flex>
                        </Col>
                        <Col span={8} style={{ alignContent: "center", justifyItems: "flex-end" }}>
                            <Button
                                type="default"
                                style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                                onClick={handleExportDocument}
                                icon={
                                    !isDownloadDoc ? (
                                        <DownloadIcon style={{ fontSize: 16 }} />
                                    ) : (
                                        <span style={{ width: 16, height: 16 }} />
                                    )
                                }
                                loading={isDownloadDoc}
                                disabled={isDownloadDoc}
                            >
                                <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                            </Button>
                        </Col>
                    </Row>
                </Card>

                <Card
                    style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                    styles={{ body: { padding: "16px" } }}
                >
                    <Row style={{ width: "100%" }}>
                        <Col span={16}>
                            <Flex gap={16} align="center">
                                <PDFIcon />
                                <Flex vertical>
                                    <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("report.pnd1_list")}</span>
                                    <span style={{ color: "#42526D" }}>{t("common.pdf_file")}</span>
                                </Flex>
                            </Flex>
                        </Col>
                        <Col span={8} style={{ alignContent: "center", justifyItems: "flex-end" }}>
                            <Button
                                type="default"
                                style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                                onClick={handleExportReport}
                                loading={isDownload}
                                disabled={isDownload}
                                icon={
                                    !isDownload ? (
                                        <DownloadIcon style={{ fontSize: 16 }} />
                                    ) : (
                                        <span style={{ width: 16, height: 16 }} />
                                    )
                                }
                            >
                                <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                            </Button>
                        </Col>
                    </Row>
                </Card>

                <Card
                    style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                    styles={{ body: { padding: "16px" } }}
                >
                    <Row style={{ width: "100%" }}>
                        <Col span={16}>
                            <Flex gap={16} align="center">
                                <TextFileIcon />
                                <Flex vertical>
                                    <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("report.pnd1_text")}</span>
                                    <span style={{ color: "#42526D" }}>{t("common.text_file")}</span>
                                </Flex>
                            </Flex>
                        </Col>
                        <Col span={8} style={{ alignContent: "center", justifyItems: "flex-end" }}>
                            <Button
                                type="default"
                                style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                                onClick={handleExportTxtReport}
                                loading={isDownloadTxt}
                                disabled={isDownloadTxt}
                                icon={
                                    !isDownloadTxt ? (
                                        <DownloadIcon style={{ fontSize: 16 }} />
                                    ) : (
                                        <span style={{ width: 16, height: 16 }} />
                                    )
                                }
                            >
                                <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                            </Button>
                        </Col>
                    </Row>
                </Card>

                <Row justify={"end"} style={{ gap: "16px" }}>
                    <Button style={{ borderRadius: "8px", height: "40px" }} type="default" onClick={() => { setIsModalOpen(false) }}>
                        <span style={{ fontWeight: "bold", color: "#344054" }}>{t("common.cancel").toUpperCase()}</span>
                    </Button>

                    <Button
                        type="primary"
                        style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", display: "flex", alignItems: "center" }}
                        onClick={handleExportZipReport}
                        loading={isDownloadZip}
                        disabled={isDownloadZip}
                        icon={
                            !isDownloadZip ? (
                                <DownloadIcon style={{ fontSize: 16 }} />
                            ) : (
                                <span style={{ width: 16, height: 16 }} />
                            )
                        }
                    >
                        <span style={{ fontWeight: "bold" }}>{t("report.downlod_doc")}</span>
                    </Button>
                </Row>
            </Space>
        </Modal>
    )
}

export default PND1ReportModal;